module.exports = __webpack_public_path__ + "img/menu-account-info.6ce04585.svg";